import { ClerkProvider } from '@clerk/react';
import { useTheme } from '@/contexts/ThemeContext';
import { getClerkAppearance } from '@/lib/clerk-appearance';

const CLERK_PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string;

if (!CLERK_PUBLISHABLE_KEY) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY environment variable');
}

interface ClerkProviderWithThemeProps {
  children: React.ReactNode;
}

/**
 * Clerk provider that automatically syncs with the app's theme.
 * Uses @clerk/themes dark theme when app is in dark mode.
 */
export function ClerkProviderWithTheme({ children }: ClerkProviderWithThemeProps) {
  const { resolvedMode } = useTheme();

  return (
    <ClerkProvider
      publishableKey={CLERK_PUBLISHABLE_KEY}
      appearance={getClerkAppearance(resolvedMode)}
      afterSignOutUrl="/sign-in"
    >
      {children}
    </ClerkProvider>
  );
}
